import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { UnavailabilityPeriod } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

/**
 * Hook to fetch all unavailability periods for the authenticated user
 */
export const useGetUnavailabilityPeriods = () => {
  const fetchWithAuth = useFetchWithAuth()

  const getUnavailabilityPeriods: QueryFunction<
    UnavailabilityPeriod[]
  > = async () => {
    const response = await fetchWithAuth(`${URL}/profile/unavailability`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
    return response
  }

  return useQuery({
    queryKey: ['unavailabilityPeriods'] as const,
    queryFn: getUnavailabilityPeriods,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
